module.exports = __webpack_public_path__ + "img/logo.0fd2b76e.png";